import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "panel" }

import { ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { ApiParams } from '@/core/http/ApiResource';
import PageLayout from '@/core/components/PageLayout.vue';
import ResourceTable from '@/core/components/resource/ResourceTable.vue';
import Column from '@/core/components/resource/Column';
import ActionColumn from '@/core/components/resource/ActionColumn';
import { Customer, useCustomer } from '@/modules/customer/Customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerIndex',
  setup(__props) {

const { $gettext } = useGettext();
const resource = useCustomer();
const defaultParams: ApiParams = {};
const customerToDelete = ref<Customer>();

const columns = [
	new Column<Customer>($gettext('Namn'), 'name', 'c.name', '+'),
	new Column<Customer>($gettext('Organisationsnummer'), 'identity_number', 'c.identity_number'),
	new Column<Customer>($gettext('Kontaktperson'), 'contact_name', 'c.contact_name'),
	new Column<Customer>($gettext('Telefonnummer'), 'phone', 'c.phone'),
	new Column<Customer>($gettext('E-postadress'), 'email', 'c.email'),
	new Column<Customer>($gettext('Demo?'), 'demo', 'c.demo')
		.withFormatter(c => c.demo ? $gettext('Ja') : ''),
	new ActionColumn<Customer>()
		.withLink(
			'users',
			'',
			(lf: Customer) => ({ name: 'customer.user.index', params: { customer_id: lf.id } }),
		)
		.withLink(
			'file',
			'',
			(lf: Customer) => ({ name: 'customer.cmsPage.index', params: { customer_id: lf.id } }),
		)
		.withEditLink((lf) => ({ name: 'customer.edit', params: { id: lf.id } }))
		.withDeleteLink((lf: Customer) => {
			customerToDelete.value = lf;
		}),
];

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createBlock(PageLayout, {
    "page-title": _unref($gettext)('Kunder')
  }, {
    "header-actions": _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
        to: {name: 'customer.create'},
        class: "button"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode(" Ny kund ", -1)
        ]))]),
        _: 1
      })), [
        [_directive_translate]
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(ResourceTable, {
          resource: _unref(resource),
          columns: columns,
          "default-params": defaultParams,
          "delete-title": _unref($gettext)('Ta bort kund'),
          "delete-name-key": "name",
          "to-delete": customerToDelete.value,
          "onUpdate:toDelete": _cache[0] || (_cache[0] = ($event: any) => ((customerToDelete).value = $event))
        }, null, 8, ["resource", "delete-title", "to-delete"])
      ])
    ]),
    _: 1
  }, 8, ["page-title"]))
}
}

})